angular.module('iqxCore')
.controller('P45Ctrl', function ($scope, FormSvc) {
	$scope.checkPermissions('CANDIDATE')
	
    FormSvc.setOptions($scope,{
      fetchAPI:'callresult/NETITSP45',
	  fetchTarget:'p45s',
	  fetchWithPersonID: true,
      multiRow:true
    })
    $scope.fetch()
    .then(function(){
    	angular.forEach($scope.p45s, function(val, key){
    		$scope.p45s[key].P1A_PrivateAddress = spliyandtidy($scope.p45s[key].P1A_PrivateAddress)
    		$scope.p45s[key].P1A_EmployerNameAddress = spliyandtidy($scope.p45s[key].P1A_EmployerNameAddress)
    		
    		$scope.p45s[key].P1A_TotalPayToDate = $scope.p45s[key].P1A_TotalPayToDate1+$scope.p45s[key].P1A_TotalPayToDate2+$scope.p45s[key].P1A_TotalPayToDate3
    		$scope.p45s[key].P2_TotalPayToDate = $scope.p45s[key].P2_TotalPayToDate1+$scope.p45s[key].P2_TotalPayToDate2+$scope.p45s[key].P2_TotalPayToDate3
    	})
    })

    function spliyandtidy(input){
    	input = input.split(',')
    	angular.forEach(input, function(val, key){
    		input[key] = input[key].replace(/^\s+|\s+$/g, '')
    	})
    	return input
    }

	$scope.PDFify = function () {
		var domID = "p45Generate"
		html2canvas(document.getElementById("p45Generate"), {
			logging: false,
		    width: 900,
		    height: 5000,
			onrendered: function (canvas) {
				let data = canvas.toDataURL()
			    var docDefinition = {
			      pageSize:{
			      	height:2200,
			      	width:595
			      },
			      pageOrientation: 'portrait',
			      content: [{
			        image: data,
			        pageBreak: 'after', 
			        width: 900,
			        fit: [900, 3250],
			        margin: [ 0,0,0,0 ]
			      }]
			    }
	            return pdfMake.createPdf(docDefinition)
	            .download( $scope.userName() + "_p45_" + Date.now() + ".pdf" )			
			}

		})
	}

    $scope.viewP45=function(p45){
		var choices=[{desc:'Download',type:'success',code:'download'},{desc:'Close',type:'primary',code:''}]
		$scope.data={
			p45:p45, 
			choices:choices
		}

	    setTimeout(function () {
	        window.print()
	    }, 500)
    }	
})
